import { GenerationJob } from "@/pages/Private/redux/copywritingOrchestration/copywritingOrchestration.slice";

/**
 * A job whose drafts are waiting to be read: generated, not yet reviewed. Reviewing one
 * consumes it (P6 D6), so this is also what separates a row that only navigates to its card
 * from one that additionally marks the drafts read and opens the panel on Chat.
 */
export const isGenerationJobReady = (job: GenerationJob): boolean =>
	job.status === "COMPLETED" && !job.reviewedAt;
